import { useSelector } from "react-redux"

import isEqual from "lodash-es/isEqual"

import { RootState } from "app/store"

export function useRedux<T>(selector: (state: RootState) => T) {
  return useSelector(selector, isEqual)
}
